module.exports = __webpack_public_path__ + "paylogo.2729ddbc.png";